module.exports = __webpack_public_path__ + "media/Autumn18420.77a98d9d.mp4";